
<div class="image-container">
    <div class="images">
        <div class="swiper-slide" >
            <a *ngIf="images.routeLink; else justImage" [href]="images.routeLink" target="_blank">
               <img [src]="images.image"  alt="Images Priview">
            </a>
            <ng-template #justImage>
                <img [src]="images.image" alt="Image Preview" class="no-cursor">
              </ng-template>
        </div>
    </div>
</div>
